import React from 'react';

import { createStackNavigator } from '@react-navigation/stack';

import { isPhone, ROLES } from '@helpers';
import { isRestrictedForOperator, RESTRICTION_CATEGORIES } from '@config/operatorRestrictions';

// Account
import Account from './v2/structure/account/account';
import AccountDetails from './v2/structure/account/accountDetails';
//

// Users
import Users from './v2/structure/users/users';
import UserDetails from './v2/structure/users/userDetails';
import UsersMobile from './v2/structure/users/users/usersMobile';
//

// Devices
import Devices from './v2/structure/devices/devices';
import DeviceDetails from './v2/structure/devices/deviceDetails';
import DevicesMobile from './v2/structure/devices/devices/devicesMobile';
//

// Machines
import MachineList from './v2/structure/machines/machines';
import MachineDetails from './v2/structure/machines/machineDetails';
import MachineConnection from './v2/structure/machines/machineConnection';
import MachinesGroupDetails from './v2/structure/machines/machinesGroupDetails';
import MachinesOperationDetails from './v2/structure/machines/machinesOperationDetails';
import MachineAssignedOperations from './v2/structure/machines/machineDetails/machineAssignedOperations';
import MachinesImnooDetails from './v2/structure/machines/machines/machineImnooDetails';
import MachineCountSettings from './v2/structure/machines/machines/machineCountSettings';
//

// Connector
import Connector from './v2/structure/connector/connector';
import FileConnector from './v2/structure/connector/fileConnector/index';
import FileConnectorDetails from './v2/structure/connector/fileConnectorDetails/index';
import LinkConnector from './v2/structure/connector/linkConnector';
//

// Company
import Company from './v2/structure/company/company';
//

// Notifications
import Notifications from './v2/structure/notifications/notifications';
import EmailReports from './v2/structure/notifications/emailReports';
//

// Support
import Support from './v2/structure/support/support';
//

// API Keys
import APIKeys from './v2/structure/APIKeys/APIKeys';
//

// Imnoo
import Imnoo from './v2/structure/Imnoo/Imnoo';

import ReInvite from './components/pages/reInvite';
import Tools from './components/tabs/mobile/tools';

import { NAVIGATION_CONFIG, SMART_FACTORY } from '@v2/pages/common/constants/base.constants';

export const routes = {
  name: 'Settings',
  nested: [
    {
      name: 'Account',
      title: `Account - ${SMART_FACTORY}`,
      nested: [
        {
          name: 'AccountScreen',
          Component: Account,
          title: `Account - ${SMART_FACTORY}`,
        },
        {
          name: 'AccountDetails',
          Component: AccountDetails({}),
          title: `Account details - ${SMART_FACTORY}`,
        },
      ],
    },
    {
      name: 'Users',
      title: `Users - ${SMART_FACTORY}`,
      nested: [
        {
          name: 'UsersScreen',
          Component: isPhone ? UsersMobile : Users,
          title: `Users - ${SMART_FACTORY}`,
        },
        {
          name: 'UserDetails',
          Component: UserDetails,
          title: `User Details - ${SMART_FACTORY}`,
        },
      ],
      roles: [ROLES.ADMINISTRATOR, ROLES.MANAGER],
    },
    {
      name: 'Devices',
      title: `Devices - ${SMART_FACTORY}`,
      nested: [
        {
          name: 'DevicesScreen',
          Component: isPhone ? DevicesMobile : Devices,
          title: `Devices - ${SMART_FACTORY}`,
        },
        {
          name: 'DeviceDetails',
          Component: DeviceDetails,
          title: `Device details - ${SMART_FACTORY}`,
        },
      ],
    },
    {
      name: 'Machines',
      title: `Machines - ${SMART_FACTORY}`,
      nested: [
        {
          name: 'MachinesScreen',
          Component: MachineList,
          title: `Machines - ${SMART_FACTORY}`,
        },
        {
          name: 'MachineDetails',
          Component: MachineDetails,
          title: `Machine Details - ${SMART_FACTORY}`,
        },
        {
          name: 'MachineAssignedOperations',
          Component: MachineAssignedOperations,
          title: `Machine Operations - ${SMART_FACTORY}`,
        },
        {
          name: 'MachinesOperationDetails',
          Component: MachinesOperationDetails,
          title: `Operations Machine - ${SMART_FACTORY}`,
        },
        {
          name: 'MachineConnection',
          Component: MachineConnection,
          title: `Machine Connection - ${SMART_FACTORY}`,
        },
        {
          name: 'MachinesGroupDetails',
          Component: MachinesGroupDetails,
          title: `Machines Group Details - ${SMART_FACTORY}`,
        },
        {
          name: 'MachinesImnooDetails',
          Component: MachinesImnooDetails,
          title: `Machines Imnoo Details - ${SMART_FACTORY}`,
        },
        {
          name: 'MachineCountSettings',
          Component: MachineCountSettings,
          title: `Machines Count Settings - ${SMART_FACTORY}`,
        },
      ],
    },
    {
      name: 'Notifications',
      title: `Notifications - ${SMART_FACTORY}`,
      nested: [
        {
          name: 'NotificationsScreen',
          Component: Notifications,
          title: `Notifications - ${SMART_FACTORY}`,
        },
        {
          name: 'EmailReports',
          Component: EmailReports,
          title: `Email Reports - ${SMART_FACTORY}`,
        },
      ],
    },
    {
      name: 'Connector',
      title: `Connector - ${SMART_FACTORY}`,
      nested: [
        {
          name: 'ConnectorScreen',
          Component: Connector,
          title: `Connector - ${SMART_FACTORY}`,
        },
        {
          name: 'FileConnector',
          Component: FileConnector,
          title: `File Connector - ${SMART_FACTORY}`,
        },
        {
          name: 'FileConnectorDetails',
          Component: FileConnectorDetails,
          title: `File Connector Details - ${SMART_FACTORY}`,
        },
      ],
    },
    {
      name: 'API Keys',
      title: `API Keys - ${SMART_FACTORY}`,
      nested: [
        {
          name: 'APIKeysScreen',
          Component: APIKeys,
          title: `API Keys - ${SMART_FACTORY}`,
        },
      ],
    },
    {
      name: 'Imnoo',
      title: `Imnoo - ${SMART_FACTORY}`,
      nested: [
        {
          name: 'ImnooScreen',
          Component: Imnoo,
          title: `Imnoo - ${SMART_FACTORY}`,
        },
      ],
    },
    {
      name: 'Company',
      title: `Company - ${SMART_FACTORY}`,
      nested: [
        {
          name: 'CompanyScreen',
          Component: Company,
          title: `Company - ${SMART_FACTORY}`,
        },
      ],
    },
    {
      name: 'Support',
      title: `Support - ${SMART_FACTORY}`,
      nested: [
        {
          name: 'SupportScreen',
          Component: Support,
          title: `Support - ${SMART_FACTORY}`,
        },
      ],
    },
    {
      name: 'ReInvite',
      Component: ReInvite,
      title: `Re-invite - ${SMART_FACTORY}`,
    },
    {
      name: 'Tools',
      Component: Tools,
      title: `Tools - ${SMART_FACTORY}`,
    },
    {
      name: 'LinkConnector',
      Component: LinkConnector,
      title: `Link Connector - ${SMART_FACTORY}`,
    },
  ],
} as const;

const stackPull = {};
const generateStackNavigator = (list) => {
  if (!list.nested) {
    return;
  }
  stackPull[list.name] = createStackNavigator();
  list.nested.forEach((i) => {
    if (i.nested) {
      generateStackNavigator(i);
    }
  });
};
generateStackNavigator(routes);

const Stack = (props) => {
  const { navigationConfig, C, role } = props;
  const { name, nested } = navigationConfig;
  const StackNavigator = stackPull[name];
  const setup = { animationEnabled: false };

  return (
    <StackNavigator.Navigator
      screenOptions={{
        ...NAVIGATION_CONFIG,
        cardStyle: {
          backgroundColor: C('Background/Light/Detail'),
        },
        ...setup,
      }}
      initialRouteName={'Account'}
    >
      {nested?.map((item) => {
        if (item.roles && !item.roles.includes(role)) {
          return null;
        }
        if (isRestrictedForOperator(role, RESTRICTION_CATEGORIES.SETTINGS_ITEMS, item.name)) {
          return null;
        }
        return (
          <StackNavigator.Screen
            screenOptions={NAVIGATION_CONFIG}
            name={item.name}
            options={{ title: item.title, presentation: item.presentation }}
            key={item.name}
          >
            {(p) =>
              item.nested ? (
                <Stack {...{ ...p, ...props, navigationConfig: item }} />
              ) : (
                <item.Component
                  {...{
                    ...p,
                    ...props,
                  }}
                />
              )
            }
          </StackNavigator.Screen>
        );
      })}
    </StackNavigator.Navigator>
  );
};

export default (props) => {
  return <Stack {...{ ...props, navigationConfig: routes }} />;
};
